<template>
    <div v-if="response">
        <page :title="response.title" v-loading="pageLoading">
            <template #actions>
                <div class="breadcrumb-wrp">
                    <el-breadcrumb separator-class="el-icon-arrow-right">
                        <el-breadcrumb-item :to="{ path: '/dashboard' }">
                            {{ $t('menu.dashboard') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: '/exams' }">
                            {{ $t('menu.exams') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>
                            {{ $route.meta.title }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </template>
            <div class="page page-test page-exam" >
                <div class="page-body">
                    <div class="intro">
                        <div class="column media">
                            <div class="cover">
                                <img :src="response.image" alt="cover">
                            </div>
                        </div>
                        <div class="column content">
                            <div class="title">{{ response.title }}</div>
                            <div class="description" v-html="response.description"></div>

                            <div class="metas">
                                <div class="meta">
                                    <div class="media">
                                        <icon source="ballot-recount-outline" />
                                    </div>
                                    <div class="text">
                                        <div class="meta-title">Soru Sayısı</div>
                                        <div class="meta-description">{{ response.metas.question_count }}</div>
                                    </div>
                                </div>
                                <div class="meta">
                                    <div class="media">
                                        <icon source="clock-outline" />
                                    </div>
                                    <div class="text">
                                        <div class="meta-title">Süre</div>
                                        <div class="meta-description">{{ response.metas.duration }} dk</div>
                                    </div>
                                </div>
                            </div>
                            <div class="action">
                                <el-button type="primary" class="fluid" @click="goRoute('/exams/' + response.id + '/start')">
                                    Sınavı Başlat
                                </el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </page>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {GET_CRUD_ITEM} from "@/store/actions.type";

export default {
    name: 'Show',
    data() {
        return {
            path: 'platform/student/tests',
            pageLoading: true,
            response: null,
        }
    },
    computed: mapGetters(['item']),
    mounted() {
        this.show();
    },
    methods: {
        show() {
            this.pageLoading = true;
            this.response = null;

            this.$store
                .dispatch(GET_CRUD_ITEM, {path: this.path, id: this.$route.params.id, process : 'intro'})
                .then(() => {
                    this.pageLoading = false;
                    this.response = this.cloneObjectData(this.item(this.storePath(this.path)));
                })
                .catch(() => {
                    this.pageLoading = false;
                    this.response = null;
                })
        },
    }
}
</script>
